import graphql from "babel-plugin-relay/macro";

export const UnpublishedAdoptedSystemDocumentTemplatesQuery = graphql`
  query UnpublishedAdoptedSystemDocumentTemplatesQuery(
    $after: String
    $first: Int
    $sort: String
  ) {
    unpublishedAdoptedSystemDocumentTemplates(sort: $sort) {
      adoptedSystemDocumentTemplates(after: $after, first: $first) {
        totalCount
        edges {
          node {
            pk
            name
            total
            adopted
            documentPk
          }
        }
      }
      error {
        statusCode
      }
      otherTabTotal
    }
  }
`;

export default UnpublishedAdoptedSystemDocumentTemplatesQuery;
